import { h } from 'preact'
import { useMemo } from 'preact/hooks'

import { TITLES } from '../../config'
import { buildYearPermalink } from '../../utils/urls'
import BackgroundTitle from '../atom/BackgroundTitle'
import ArchiveNavigation from '../molecule/ArchiveNavigation'
import { AsSiteContentEntry } from '../molecule/SiteContent'
import { formatDateParts } from '../../date/format'
import LinkWrapper from '../atom/link-wrapper'

import { MonthGroupedArchiveEntries } from './archive-page'

const NavMenu = AsSiteContentEntry(ArchiveNavigation)

const YearArchive = (props) => {
  const { year, rel = {}, entries } = props

  const { year: formatted } = useMemo(
    () => formatDateParts({ year }),
    [year],
  )

  return (
    <>
      <BackgroundTitle corner={false} light border small>
        {TITLES.YEAR}: <LinkWrapper href={buildYearPermalink({ year })}>{formatted}</LinkWrapper>
      </BackgroundTitle>

      <MonthGroupedArchiveEntries entries={entries} />

      <NavMenu withMargin {...rel} />
    </>
  )
}

export default YearArchive
